import Cookies from "js-cookie";
var CryptoJs = require("crypto-js");

// Function to encrypt data using AES encryption
export const encrypt = (key, data) => {
  return CryptoJs.AES.encrypt(JSON.stringify(data), key).toString();
};

// Function to decrypt data using AES decryption
export const decrypt = (key, data) => {
  var decryptData = CryptoJs.AES.decrypt(data, key);
  return JSON.parse(decryptData.toString(CryptoJs.enc.Utf8));
};

// Function to set a cookie with encrypted data
export const setCookie = (key, data, options = {}) => {
 
  const encryptData = encrypt(key + "ADMIN@123!", data);
  const defaultOptions = {
    secure: window.location.protocol === 'https:', 
    expires: 1,
    path: "/",
    sameSite: 'Lax',
  };
  Cookies.set(key, encryptData, { ...defaultOptions, ...options });
};

// Function to get and decrypt a cookie
export const getCookie = (key) => {
 
  const cookieData = Cookies.get(key);
  return cookieData ? decrypt(key + "ADMIN@123!", cookieData) : null;
};

// Function to delete a Cookie
export const deleteCookie = (key) => {
  Cookies.remove(key, { path: "/", domain: window.location.hostname });
};

// Function to get the authenticated user detail
export const getAuthToken = () => {
  return getCookie("_USER_AUTH_");
};

// Transit encryption helpers for sensitive API fields.
// Accept both FE and BE-style names to avoid runtime key mismatch issues.
const getTransitKey = () => {
  const key =
    window.env?.REACT_APP_TRANSIT_ENC_KEY ||
    window.env?.TRANSIT_ENC_KEY ||
    process.env.REACT_APP_TRANSIT_ENC_KEY ||
    process.env.TRANSIT_ENC_KEY ||
    "";
  return String(key).trim();
};

export const encryptForTransit = (data) => {
  const key = getTransitKey();
  if (!key || !data) return data;
  return CryptoJs.AES.encrypt(JSON.stringify(data), key).toString();
};

export const decryptFromTransit = (data) => {
  const key = getTransitKey();
  if (!key || !data) return data;
  try {
    var decryptData = CryptoJs.AES.decrypt(data, key);
    return JSON.parse(decryptData.toString(CryptoJs.enc.Utf8));
  } catch {
    return data;
  }
};

/** Normalize base64 (trim, strip inner whitespace, restore = padding) for OpenSSL/CryptoJS ciphertext. */
export const normalizeTransitCiphertextBase64 = (value) => {
  if (value == null || typeof value !== "string") return "";
  const t = value.trim().replace(/\s/g, "");
  if (!t) return "";
  const pad = (4 - (t.length % 4)) % 4;
  return t + "=".repeat(pad);
};

/** True if base64 decodes to OpenSSL "Salted__" + salt + ciphertext (same shape as encryptForTransit). */
export const isOpenSslSaltedCiphertextBase64 = (value) => {
  try {
    const b64 = normalizeTransitCiphertextBase64(value);
    if (!b64) return false;
    const bin = atob(b64.replace(/-/g, "+").replace(/_/g, "/"));
    return bin.length >= 8 && bin.slice(0, 8) === "Salted__";
  } catch {
    return false;
  }
};

/** Normalize phase fields from API (snake_case or camelCase) for UI lists and navigation. */
export function normalizeProjectPhasePayload(raw) {
  if (!raw || typeof raw !== "object") return raw;
  const id = raw.projectPhaseId ?? raw.project_phase_id;
  return {
    ...raw,
    projectPhaseId: id != null ? id : raw.projectPhaseId,
    phaseStatus: raw.phaseStatus ?? raw.phase_status,
    reraNo: raw.reraNo ?? raw.rera_no,
    reraStartDate: raw.reraStartDate ?? raw.rera_start_date,
    reraEndDate: raw.reraEndDate ?? raw.rera_end_date,
  };
}

/**
 * Merge phases from GET with any optimistic rows not yet present on the server
 * (avoids wiping a newly created phase when a stale refetch completes).
 */
export function mergeProjectPhasesWithServer(serverPhases, optimisticPhases) {
  const map = new Map();
  const put = (p) => {
    const n = normalizeProjectPhasePayload(p);
    const id = n?.projectPhaseId ?? n?.project_phase_id;
    if (id == null) return;
    map.set(String(id), n);
  };
  (serverPhases || []).forEach(put);
  (optimisticPhases || []).forEach((p) => {
    const n = normalizeProjectPhasePayload(p);
    const id = n?.projectPhaseId ?? n?.project_phase_id;
    if (id == null) return;
    if (!map.has(String(id))) put(p);
  });
  return Array.from(map.values());
}